import { getAppIcon } from '@wellesley/apps'
import { cropName } from 'helpers/cropName'
import { FC } from 'react'
import { Avatar, AvatarFallback, AvatarImage, cn } from '@wellesley/ui'

export type AppAvatarProps = {
  name: string
  icons?: string[] | null
  className?: string
}

export const AppAvatar: FC<AppAvatarProps> = ({ name, icons, className }) => {
  const icon = icons && getAppIcon(icons, 40)

  return (
    <Avatar className={cn('h-8 w-8 rounded-sm', className)}>
      {icon && <AvatarImage src={icon} alt="app-avatar" />}
      <AvatarFallback className="bg-slate-200">{cropName(name)}</AvatarFallback>
    </Avatar>
  )
}
